export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAILURE = 'USER_LIST_FAILURE';
export const USER_LIST_DISMISS = 'USER_LIST_DISMISS';

export const RETRIEVE_DOWNLOAD_RULES_REQUEST = 'RETRIEVE_DOWNLOAD_RULES_REQUEST';
export const RETRIEVE_DOWNLOAD_RULES_SUCCESS = 'RETRIEVE_DOWNLOAD_RULES_SUCCESS';
export const RETRIEVE_DOWNLOAD_RULES_FAILURE = 'RETRIEVE_DOWNLOAD_RULES_FAILURE';
